import { ColumnDef } from '@tanstack/react-table';
import { Trash } from '@phosphor-icons/react';
import { DataTableColumnHeader } from '@/components/core';
import { Button } from '@/components/ui-kit/button';
import { formatDateOnly, formatOrgDateTime } from '@/lib/utils/custom-date/custom-date';
import { SurveyBatch } from '../../types/survey.types';

interface CreateBatchTableColumnsProps {
  t: (key: string) => string;
  onDelete: (batch: SurveyBatch) => void;
}

export const createBatchTableColumns = ({
  t,
  onDelete,
}: CreateBatchTableColumnsProps): ColumnDef<SurveyBatch>[] => [
  {
    id: 'Title',
    meta: { filter: { type: 'text' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('TITLE')} />,
    accessorFn: (row) => row.Title,
  },
  {
    id: 'SentDateUtc',
    meta: { filter: { type: 'datetime' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('SENT_DATE')} />,
    accessorFn: (row) => row.SentDateUtc,
    cell: ({ row }) =>
      formatOrgDateTime(row.original.SentDateUtc, row.original.Timezone || undefined) || '-',
  },
  {
    id: 'Deadline',
    meta: { filter: { type: 'date' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('DEADLINE')} />,
    accessorFn: (row) => row.Deadline,
    cell: ({ row }) => formatDateOnly(row.original.Deadline) || '-',
  },
  {
    id: 'Progress',
    // Completed out of total recipients; not one field the server can sort on.
    enableSorting: false,
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('PROGRESS')} />,
    accessorFn: (row) => `${row.CompletedCount}/${row.TotalRecipients}`,
  },
  {
    id: 'actions',
    // Card: top right, as the old portal's card header.
    meta: { mobile: 'badge' as const },
    header: () => <span className="text-xs font-medium">{t('ACTION')}</span>,
    enableSorting: false,
    enableHiding: false,
    cell: ({ row }) => (
      <Button
        variant="ghost"
        size="icon"
        onClick={() => onDelete(row.original)}
        aria-label={t('DELETE')}
      >
        <Trash className="size-4" />
      </Button>
    ),
  },
];
